import { getTrafficCCTVs } from '../../api/trafficApi'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'

const state = {
    cctvs: {}
}

const getters = {
    getCCTVS: state => {
        return state.cctvs
    }
}

const actions = {
    async updateTrafficCCTVs({ commit }, condition) {
        commit('CCTVs', await getTrafficCCTVs(condition))
    },

}

const mutations = {
    CCTVs(state, data) {
        if (!Utils.isEmptyObject(data)) {
            state.cctvs = data
        }

    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}